import { createFileRoute } from "@tanstack/react-router";
import { PageHero, PageIntro } from "@/components/site/PageHero";
import { HostingPlans } from "@/components/site/HostingPlans";
import { Reveal } from "@/components/site/Reveal";
import { Section } from "@/components/site/Section";
import { whatsappLink } from "@/content/site";
import { useSiteSection } from "@/hooks/useSiteContent";

export const Route = createFileRoute("/hospedagem")({
  head: () => ({
    meta: [
      { title: "Hospedagem de sites e e-mail profissional | Contato Internet" },
      {
        name: "description",
        content:
          "Planos de hospedagem Linux com cPanel, e-mails profissionais, banco de dados e suporte local da Contato. A partir de R$ 9,90 por mês.",
      },
      { property: "og:title", content: "Planos de hospedagem — Contato Internet" },
      {
        property: "og:description",
        content: "Hospedagem Linux com cPanel, e-mails profissionais e suporte de verdade.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: HospedagemPage,
});

function HospedagemPage() {
  const hosting = useSiteSection("hosting");
  return (
    <>
      <PageHero eyebrow={hosting.eyebrow} title={hosting.title} subtitle={hosting.subtitle} />
      <PageIntro text={hosting.text} />

      <Reveal variant="fade-up">
        <HostingPlans hideHeader />
      </Reveal>

      <Section reveal title="Precisa de um plano sob medida?">
        <div className="text-center">
          <a
            href={whatsappLink("Olá, estou interessado em contratar Hospedagem.")}
            target="_blank"
            rel="noreferrer"
            className="inline-flex rounded-full bg-brand-yellow px-8 py-3.5 text-sm font-extrabold uppercase tracking-wide text-brand-yellow-foreground transition-transform hover:-translate-y-0.5"
          >
            Falar com a Contato
          </a>
        </div>
      </Section>
    </>
  );
}
